
<template>
    <div class="shipping-methods">
        <div class="row" v-if="!shippingMethods.warnings.length && !showDialog">
            <div v-for="(shippingmethod,index) in visibleShipping" v-bind:class="[{'on' : shippingmethod.selected, 'disabled' : shippingmethod.disabled }, shippingmethod.alias, 'col']" v-bind:title="shippingmethod.description">
                <div v-on:click="selectShipping(shippingmethod)" class="shipping method-name" :data-shippingmethodid="shippingmethod.shippingMethodId" :data-shippingratecomputationmethodid="shippingmethod.shippingRateComputationMethodId">
                    <label class="enableFrom" v-if="shippingmethod.disabled && shippingmethod.enableFromPrice >0" :title="shippingmethod.message"><span :class="'icon icon-' + shippingmethod.alias"></span><span> > {{shippingmethod.enableFromPrice}} EURO</span></label>
                    <label v-else>{{shippingmethod.name}}</label>
                </div>
            </div>
        </div>

        <div class="row" v-if="showDialog">
            <div v-for="(dialogChoice,index) in dialogChoices" v-bind:class="[ 'on' , dialogChoice.alias, 'col' ]" v-bind:title="dialogChoice.description">
                <div v-on:click="selectDialogChoice(dialogChoice)" class="shipping dialog method-name">
                    <label>{{dialogChoice.name}}</label>
                </div>
            </div>
        </div>

        <div class="row shipping-methods message-error" v-if="shippingMethods.warnings.length">
            <ul>
                <li v-for="warning in shippingMethods.warnings">{{warning}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { services, EventBus } from '../Services/Services'
    import shoppingCartService from '../Services/ShopingCartService';

    // private
    var reloadCart = false;

    export default {

        props: {
            "getshippingroute": String // the route url to the api
        },

        data: function () {
            // global shipping methods model
            return {
                shippingMethods: services.shippingMethods,
                showDialog: false,
                dialogChoices: [{ selected: true, alias: 'qrScan', disabled: false, name: 'SCAN QR' }, { selected: false, disabled: false, alias: 'cancelTable', name: 'ZONDER QR' }]
            }
        },

        methods: {
            /**
             * Click handler on the shipping method
             * @param {object} item - the shipping method
             */
            selectShipping: function (item) {

                if (item.customAction && item.customAction == 'ShowDialog') {
                    this.showDialog = true;
                    shoppingCartService.shoppingCart.continueButtonDisabled = true;
                    return;
                }

                if (item.alias && item.alias == 'camera') {
                    window.location.href = '/qrscan.html';
                    return;
                }

                if (item.disabled) {
                    return;
                }

                // check for price updates, in order to reload the cart
                var oldPrice = null;

                for (var i in this.shippingMethods.shippingmethods) {
                    if (this.shippingMethods.shippingmethods[i].selected) {
                        this.shippingMethods.shippingmethods[i].selected = false;
                        oldPrice = this.shippingMethods.shippingmethods[i].fee.priceInclTax;
                    }
                }

                if (oldPrice !== item.fee.priceInclTax) {
                    // reload cart, total price may difer.
                    reloadCart = true;
                }

                item.selected = true;
                // send it to api
                Amazilia.sendShippingOptions('shippingoption=' + item.shippingRateComputationMethodId + '_' + item.shippingMethodId);
            },

            selectDialogChoice: function (item) {

                shoppingCartService.shoppingCart.continueButtonDisabled = false;
                this.showDialog = false;

                if (item.alias == 'qrScan') {
                    window.setTimeout(function () {
                        window.location.href = '/qrscan.html';
                    }, 10);
                } else {
                    // set shipping to 'afhalen', serverside removes the tablenumber cartitem
                    var afhalen = this.shippingMethods.shippingmethods.find(a => a.alias == 'afhalen');

                    if (afhalen) {
                        afhalen.customAction = null;
                        this.selectShipping(afhalen);
                    }
                }

            },
        },

        computed: {
            visibleShipping: function () {

                return services.shippingMethods.shippingmethods.filter(a => !a.hide);

                //var _shipping = [];
                //for (var i in services.shippingMethods.shippingmethods) {
                //  if (!i.hide) {
                //    _shipping.push[i];
                //  }
                //}
                //return _shipping;
            }
        },

        mounted: function () {
            var vm = this;

            $(Amazilia).on('addedToBasket', function (e, data) {
                // get the shipping methods from api
                services.loadShippingMethods();
            });

            // get the shipping methods from api
            services.loadShippingMethods();

            // call back handler, shippingmethod selection is processed by api, and returned here
            $(Amazilia).on('shippingMethodSubmited', function (e, data) {

                vm.showDialog = false;

                // display message if any errors
                var html = '';
                if (!data.success) {
                    html = '<ul class="cart-warnings">';
                    for (var i in data.message) {
                        html += '<li>' + data.message[i] + '</li>';
                    }
                    html += '</ul>';

                    $(html).modal();
                    return;
                }

                // new data
                vm.shippingMethods.shippingmethods = data.data.shippingmethods;
                vm.shippingMethods.warnings = data.data.warnings;

                // reload cart by emitting a global event, if price changes detected
                if (true || reloadCart) {
                    EventBus.$emit('reload-cart', null);
                    reloadCart = false;
                }
            });
        }
    }
</script>



// WEBPACK FOOTER //
// Vue/Src/Components/delivery-methods.vue